import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedDataService } from './services/app/shared-service/shared-data.service';
import { AuthService } from './components/auth/service/auth.service';
import { NavigationStart, Router } from '@angular/router';
import { DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';
import * as moment from 'moment-timezone';
import { Observable, takeUntil } from 'rxjs';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { WebPushService } from './services/app/web-push/web-push.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn = false;

  constructor(
    private sharedDataService: SharedDataService,
    private webPushService: WebPushService
  ) { }

  ngOnInit() {
    this.getUser();
    this.webPushService.initServiceWorker();
  }

  getUser() {
    this.sharedDataService
    .getUser()
    // .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(user => {
      if (user) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    });
  }

  ngOnDestroy(): void {
  }

}
